import { render, staticRenderFns } from "./add-workshop-location.vue?vue&type=template&id=6a808b45&scoped=true"
import script from "./add-workshop-location.vue?vue&type=script&lang=js"
export * from "./add-workshop-location.vue?vue&type=script&lang=js"
import style0 from "./add-workshop-location.vue?vue&type=style&index=0&id=6a808b45&prod&lang=css"
import style1 from "./add-workshop-location.vue?vue&type=style&index=1&id=6a808b45&prod&lang=css&scoped=true"
import style2 from "./add-workshop-location.vue?vue&type=style&index=2&id=6a808b45&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a808b45",
  null
  
)

export default component.exports